// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__11VnT","sticky":"logo_sticky__1YRHo"};